import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChangeOrderProductDate = _resolveComponent("ChangeOrderProductDate")

  return (_openBlock(), _createBlock(_component_ChangeOrderProductDate, {
    id: _ctx.id,
    isQuote: true
  }, null, 8, ["id"]))
}